<template>
    <nav class="config-nav">
        <div class="config-nav__body">
            <h2 class="config-nav__title">{{ $t('phu_production.configuration.title') }}</h2>
            <ul class="config-nav__list">
                <li v-for="section in sections" :key="section.id">
                    <button
                        type="button"
                        class="config-nav__item"
                        :class="{ 'config-nav__item--active': section.id === active }"
                        :aria-current="section.id === active ? 'true' : 'false'"
                        @click="$emit('select', section.id)"
                    >
                        <span>{{ section.label }}</span>
                        <span class="config-nav__count">{{ section.count }}</span>
                    </button>
                </li>
            </ul>
        </div>

        <button type="button" class="config-nav__back" @click="$emit('back')">
            <i class="i-andy-chevron-left i-andy-s" aria-hidden="true"></i>
            {{ $t('phu_production.configuration.back') }}
        </button>
    </nav>
</template>

<script>
export default {
    name: 'ConfigNav',
    props: {
        sections: { type: Array, required: true },
        active: { type: String, default: '' }
    }
}
</script>

<style lang="scss" scoped>
@import '~@/components/domain/phu-production/styles/tokens';

.config-nav {
    @include display-flex();
    @include flex-direction(column);
    gap: $phu-gap;
    height: 100%;
    min-height: 0;
    padding: 8px;
    border-radius: $phu-radius-s;
    background-color: $phu-surface;
    overflow: hidden;

    &__back {
        @include display-flex();
        @include align-items(center);
        @include justify-content(center);
        gap: 8px;
        flex-shrink: 0;
        width: 100%;
        min-height: 40px;
        margin-top: auto;
        border: none;
        border-radius: $phu-radius-s;
        background-color: $phu-button;
        font-family: $text-bold;
        font-size: 1rem;
        color: $phu-primary;
        cursor: pointer;
    }

    &__body {
        @include display-flex();
        @include flex-direction(column);
        gap: 16px;
        padding: 8px;
    }

    &__title {
        margin: 0;
        font-family: $text-bold;
        font-size: 1.125rem;
        color: $phu-primary;
    }

    &__list {
        @include display-flex();
        @include flex-direction(column);
        gap: 4px;
        margin: 0;
        padding: 0;
        list-style: none;
    }

    &__item {
        @include display-flex();
        @include align-items(center);
        @include justify-content(space-between);
        width: 100%;
        padding: 8px;
        border: none;
        border-radius: $phu-radius-s;
        background: transparent;
        font-family: $text;
        font-size: 1rem;
        color: $phu-primary;
        cursor: pointer;

        &--active {
            background-color: $phu-button;
            font-family: $text-bold;
        }
    }

    &__count {
        font-family: $text;
        color: $phu-contrast-text;
    }
}
</style>
